$(document).ready(function () {
  const reviewCarousel = $(".quotes.review").owlCarousel({
    nav: true,
    dots: false,
    rewind: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 1,
    responsive: {
      0: {
        items: 1,
        dots: true
      },
      768: {
        items: 1,
        dots: true
      },
      1000: {
        nav: true,
        items: 1
      }
    }
  });

  $(".quotes.opinion").owlCarousel({
    nav: true,
    dots: false,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 1,
    responsive: {
      0: {
        items: 1,
        dots: true
      },
      768: {
        items: 1,
        dots: true
      },
      1000: {
        nav: true,
        items: 1
      }
    }
  });

  $(".partner_logos").owlCarousel({
    nav: false,
    dots: false,
    loop: false,
    items: 4,
    stagePadding: 40,
    responsive: {
      0: {
        items: 2
      },
      768: {
        items: 2
      }
    }
  });

  $(".gallery-items").owlCarousel({
    nav: true,
    loop: true,
    dots: false,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    margin: 48,
    items: 8,
    responsive: {
      0: {
        items: 1
      },
      662: {
        items: 2
      },
      750: {
        items: 3
      },
      1025: {
        items: 4
      }
    }
  });

  $(".product-map").owlCarousel({
    nav: true,
    dots: true,
    navContainerClass: 'owl-nav',
    center: true,
    items: 3,
    touchDrag: false,
    mouseDrag: false,
    loop: true,
    navText: ['Prev.', 'Next'],
    lazyLoad: true,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  $(".first-product, .second-product, .third-product").owlCarousel({
    nav: true,
    dots: false,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 3,

    responsive: {
      0: {
        items: 1
      }
    }
  });

  $(".slider-reviews").owlCarousel({
    nav: true,
    dots: true,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 3,

    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  $(".features-product-mobile").owlCarousel({
    nav: false,
    dots: true,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 1,

    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  $(".diagram-carousel-tuft").owlCarousel({
    nav: false,
    dots: true,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 1,

    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  $(".product-comapre-wrapper.owl-carousel").owlCarousel({
    nav: false,
    dots: true,
    navElement: 'div',
    margin: 10,
    dotsContainerClass: 'owl-dots',
    stagePadding: 20,
    center: true,
    items: 3,

    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1
      }
    }
  });

  $(".reviews .quotes").owlCarousel({
    nav: true,
    dots: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    center: true,
    items: 3,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 1,
        dots: true
      },
      1000: {
        items: 1
      }
    }
  });

  $(".news-owl-carousel").owlCarousel({
    nav: false,
    dots: false,
    loop: false,
    items: 1,
    stagePadding: 0,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });

  $("#home_press .logos .logo").on('click', function () {
    var idx = $(this).attr('data-id');
    $('.quotes').trigger('to.owl.carousel', Number(idx));
    $("#home_press .logos .logo").removeClass('active');
    $(this).addClass('active')
  });

  $(".product-map-items .bullet").on('click', function (event) {
    event.preventDefault();
    $(".product-map-items .bullet").removeClass('active');
    $(this).addClass('active');
    goToNextCarouselPage($(event.target).attr('carousel'), $(event.target).attr('index'))
  });

  function goToNextCarouselPage(car, pos) {
    $('.' + car).trigger('to.owl.carousel', Number(pos));
  };

  $(".product-map").on('changed.owl.carousel', function (e) {
    var idx = e.page.index;
    console.log(e.page.index);
    $(".product-interactive-detail-gallery").removeClass('active');
    $(".product-interactive-detail-gallery:eq(" + idx + ")").addClass('active');
  });

  $("#product-explore ul li").on('click', function (event) {
    event.preventDefault();
    $("#product-explore ul li").toggleClass('active');
    $(".product_container").toggleClass('active');
  });

  $(function fudRemoval() {
    var $feature_list = $("#product_accordion .feature_list"),
      $half_white_bg = $("#product_accordion .half_white_bg"),
      $half_image_bg = $("#product_accordion .half_image_bg"),
      $h1 = $("#product_accordion .header h1"),
      $h4 = $("#product_accordion .header h4");

    var touchsupport =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;
    if (!touchsupport) {
      $("#product_accordion").addClass("non-touch");
    }

    $("#product_accordion .feature_list dt").click(function () {
      var $current_expanded_dd = $("#product_accordion dd.expanded");

      if (
        $(this)
          .siblings("dd")
          .hasClass("expanded")
      ) {
        if (window.innerWidth > 600) {
          $feature_list.find("dd").removeClass("expanded");
          $feature_list.find(".plus").removeClass("active");
        }
        $(this)
          .find(".plus")
          .removeClass("active");
        $(this)
          .siblings("dd")
          .slideToggle(300);
        $(this)
          .siblings("dd")
          .removeClass("expanded");
        $feature_list.removeClass("expanded");
        $half_white_bg.removeClass("opened");
        $half_image_bg
          .removeClass("active")
          .removeClass($current_expanded_dd.siblings("dt").data("id"));
        $h1.show();
        $h4.show();
        return;
      }

      if (!$feature_list.hasClass("expanded")) {
        $feature_list.addClass("expanded");

        if (window.innerWidth > 660) {
          $h1.hide();
          $h4.hide();
        }
      }

      if (window.innerWidth > 660) {
        $half_white_bg.addClass("opened");
        $half_image_bg
          .removeClass("active " + $current_expanded_dd.siblings("dt").data("id"))
          .addClass($(this).data("id"));

        if ($(this).data("id") !== "risk_free") {
          $half_image_bg.addClass("active");
        }

        $(this)
          .closest("li")
          .siblings("li")
          .find(".plus")
          .removeClass("active");
        $(this)
          .closest("li")
          .siblings("li")
          .find("dd.expanded")
          .slideToggle(300)
          .removeClass("expanded");
      }

      $(this)
        .find(".plus")
        .addClass("active");
      $(this)
        .siblings("dd")
        .slideToggle(300)
        .addClass("expanded");
    });
  });

  $(function () {
    function renderTemplate(el) {
      let $video = $(el).closest(".video-tuft");

      $video
        .addClass("visible")
        .find(".inner")
        .html(getVideoTemplate(el.dataset.id));

      $video.on("click", "[data-id=close]", e => {
        e.preventDefault();

        $(e.target)
          .closest(".video")
          .removeClass("visible")
          .find(".inner")
          .html("");
      });
    }

    let videoButtons = document.querySelectorAll(
      "[data-id=truth_video], [data-id=story_video], [data-id=sleeponit_video], [data-id=unboxing_video], [data-id=sheets_video]"
    );

    /**/
    const videoTemplate = (styleClass, id) =>
      `<iframe allowfullscreen class="${styleClass}" frameborder="0" height="360" width="640" src="https://www.youtube-nocookie.com/embed/${id}?rel=0&amp;amp;controls=1&amp;amp;showinfo=0&amp;amp;autoplay=1"></iframe>`;

    const storyVideoTemplate = () => videoTemplate("story-video", "KpuWiCB49_0");

    const sleeponitVideoTemplate = () =>
      videoTemplate("sleeponit-video", "jSXd7X1F-LY");

    const truthVideoTemplate = () => videoTemplate("truth-video", "6hX_BWxSnSI");

    const unboxingVideoTemplate = () =>
      videoTemplate("unboxing-video", "VNvu9XjN_b8");

    const getVideoTemplate = name => {
      let templateFunction = {
        sheets_video: storyVideoTemplate,
        sleeponit_video: sleeponitVideoTemplate,
        story_video: storyVideoTemplate,
        truth_video: truthVideoTemplate,
        unboxing_video: unboxingVideoTemplate
      }[name];

      return `<a data-id="close" href="#"></a>${templateFunction()}`;
    };
    /**/
    videoButtons.forEach(btn =>
      btn.addEventListener("click", e => {
        e.preventDefault();
        renderTemplate(btn);
      })
    );
  });

  $(function () {
    $("[data-id=nav_story_video]").on("click", function (e) {
      e.preventDefault();

      let videoButtons = document.querySelectorAll(
        "[data-id=truth_video], [data-id=story_video], [data-id=sleeponit_video], [data-id=unboxing_video], [data-id=sheets_video]"
      );
      /**/
      const videoTemplate = (styleClass, id) =>
        `<iframe allowfullscreen class="${styleClass}" frameborder="0" height="360" width="640" src="https://www.youtube-nocookie.com/embed/${id}?rel=0&amp;amp;controls=1&amp;amp;showinfo=0&amp;amp;autoplay=1"></iframe>`;

      const storyVideoTemplate = () => videoTemplate("story-video", "KpuWiCB49_0");

      const sleeponitVideoTemplate = () =>
        videoTemplate("sleeponit-video", "jSXd7X1F-LY");

      const truthVideoTemplate = () => videoTemplate("truth-video", "6hX_BWxSnSI");

      const unboxingVideoTemplate = () =>
        videoTemplate("unboxing-video", "VNvu9XjN_b8");

      const getVideoTemplate = name => {
        let templateFunction = {
          sheets_video: storyVideoTemplate,
          sleeponit_video: sleeponitVideoTemplate,
          story_video: storyVideoTemplate,
          truth_video: truthVideoTemplate,
          unboxing_video: unboxingVideoTemplate
        }[name];

        return `<a data-id="close" href="#"></a>${templateFunction()}`;
      };
      /**/
      videoButtons.forEach(btn =>
        btn.addEventListener("click", e => {
          e.preventDefault();
          renderTemplate(btn);
        })
      );
      var template = getVideoTemplate("story_video");

      $(e.target)
        .closest(".dropdown")
        .find(".dropdown.about")
        .addClass("inactive");

      $(e.target)
        .closest("body")
        .find("#nav_story_video")
        .find(".video-tuft")
        .addClass("visible")
        .find(".inner")
        .html(template);

      $("#nav_story_video").css("z-index", 10);

      setTimeout(function () {
        $(".dropdown").removeClass("inactive");
      }, 2000);
    });

    $(".video-tuft").on("click", "[data-id=close]", function (e) {
      e.preventDefault();
      $(e.target)
        .closest("body")
        .find(".video-tuft")
        .removeClass("visible")
        .find(".inner")
        .html("");
    });
  });

  $(function () {
    var $accordion_option = $("#tn_accordion ul li dl dt > a");

    $accordion_option.off("click.tn_accordion_show_detail");
    $accordion_option.on("click.tn_accordion_show_detail", function (e) {
      e.preventDefault();
      $(this).closest("li").toggleClass("active");
    });
  });

  /* function to make work news  in press page */

  $(function () {
    $("#recent_news li").click(function () {
      window.open(
        $(this)
          .find("a")
          .attr("href")
      );
    });
    $("#recent_news li a").click(function (e) {
      e.stopPropagation();
    });
    $("#recent_news li").each(function () {
      if ($(this).data("id") > 12) {
        $(this).hide();
      }
    });

    if ($("#recent_news li").length > 12) {
      $("#recent_news a.button.secondary")
        .show()
        .click(function (e) {
          e.preventDefault();
          $(this).hide();
          $("#recent_news li").show();
        });
    }
  })

  /* social media in press page */

  $(".preview").owlCarousel({
    nav: true,
    dots: false,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    items: 4,
    /*navText : ["<button type='button' role='presentation' class='owl-prev'><span aria-label='Previous'>‹</span></button>","<button type='button' role='presentation' class='owl-next'><span aria-label='Next'>›</span></button>"],*/

    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
      },
      767: {
        items: 1,
        nav: false,
        dots: true,
      },
      900: {
        items: 1,
        nav: false,
        dots: true,
      },
      1000: {
        items: 4
      }
    }
  });

  $(".modalInsta").owlCarousel({
    nav: true,
    dots: false,
    loop: true,
    navElement: 'div',
    navContainerClass: 'owl-nav',
    items: 1,
    /*navText : ["<button type='button' role='presentation' class='owl-prev'><span aria-label='Previous'>‹</span></button>","<button type='button' role='presentation' class='owl-next'><span aria-label='Next'>›</span></button>"],*/

    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
      },
      767: {
        items: 1,
        nav: false,
        dots: true,
      },
      900: {
        items: 1,
        nav: false,
        dots: true,
      },
      1000: {
        items: 1
      }
    }
  });
  (function () {
    $("#ugc #instagram ul.preview").on("click", "li", function () {
      $("#ugc_viewer_overlay").show();
      $("#ugc #instagram .ig_modal").show();
      $("#ugc #instagram .ig_modal ul").trigger(
        "to.owl.carousel",
        $(this).data("id") - 1
      );
    });

    $("#ugc #instagram .ig_modal a.close").click(function (e) {
      e.preventDefault();
      $("#ugc_viewer_overlay").hide();
      $("#ugc #instagram .ig_modal").hide();
    });

    $("#ugc_viewer_overlay").click(function () {
      $("#ugc_viewer_overlay").hide();
      $("#ugc #instagram .ig_modal").hide();
    });
  })();
  $(function productBuySlides() {
    var slides = $("#product_buy #slides");

    slides.owlCarousel(
      $.extend({}, {
        nav: false,
        dots: true,
        loop: true,
        autoplaySpeed: 300,
        navSpeed: 300,
        dotsSpeed: 300,
      })
    );

    var slidesNavPrev = $('<div class="slides-nav-prev" />').append(
      $("<div/>").click(function () {
        slides.trigger("prev.owl.carousel");
      })
    );
    var slidesNavNext = $('<div class="slides-nav-next" />').append(
      $("<div/>").click(function () {
        slides.trigger("next.owl.carousel");
      })
    );
    slides.append(slidesNavPrev);
    slides.append(slidesNavNext);
  });

  // Dropdown Menu Fade    
  $(".dropdown").hover(
    function () {
      $('.dropdown-menu.desktop-menu', this).fadeIn("fast");
    },
    function () {
      $('.dropdown-menu.desktop-menu', this).fadeOut("fast");
    });

  $(".dropdown").click(
    function () {
      $('.dropdown-menu.menu-mobile-drop', this).fadeIn("fast");
    },
    function () {
      $('.dropdown-menu.menu-mobile-drop', this).fadeOut("fast");
    });

  // Mobile Menu    
  $(".mobiletuft-nav .dropdown-toggle").click(
    function () {
      var flecha_active = 0;
      var flecha = $(this).find('.flechita-mover');
      if (flecha.hasClass('active')) {
        flecha_active = 1;
      }
      $('.flechita-mover').removeClass('active');
      if (flecha_active == 0) {
        flecha.addClass("active");
      }

    })
  $(".mobiletuft-nav .card-link").click(
    function (e) {
      e.preventDefault();
      var flecha_active = 0;
      var flecha = $(this);

      var id = flecha.data('target');
      var collapseAbout = $(id);
      if (flecha.hasClass('active')) {
        flecha_active = 1;
      }
      flecha.removeClass('active');
      collapseAbout.removeClass('show');
      if (flecha_active == 0) {
        flecha.addClass("active");
        collapseAbout.stop(true, true).addClass("show", 500);
      }
      return false;
    })


  // modal productos
  $('#modalSizeChart').on('shown.bs.modal', function () {
    $('#myInput').trigger('focus')
  })

  $(function press() {
    var $quotes = $("#home_press .quotes");
    $("#home_press .logo").click(function () {
      $quotes.trigger("to.owl.carousel", [Number($(this).data("id")), 300]);
      $("#home_press .logo").removeClass("active");
      $(this).addClass("active");
    });
    $quotes.on("changed.owl.carousel", function (e) {
      var i = e.item.index;
      console.log({ i, item: $(`#home_press .logo[data-id="${i}"]`) });
      $("#home_press .logo").removeClass("active");
      $(`#home_press .logo[data-id="${i}"]`).addClass("active");
    });
  });

  /* newsLetter*/
  $(function () {

    var myform = $("#contact_form");
    myform.on("submit", function (ev) {
      ev.preventDefault();

      var userEmail = $('#contact_email');
      if (!myform.valid())
        return;
      /*var emailRefex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
       var emailFormat = emailRefex.test(userEmail.val());// this return result in boolean type
      if (emailFormat) { */

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          $('#success-subscribe').show();
          $('#success-subscribe').delay(1000).fadeOut();
          /*$("#btn_submit_newsletter").prop('disabled', false); */
          userEmail.val('');
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
          // some code here
        }
      });

      /* } else {
        $('#error-subscribe').show();
        $('#error-subscribe').delay(1000).fadeOut();
        $("#btn_submit_newsletter").prop('disabled', false);
      } */

    });


  });

  $(function () {
    var myform = $("#newsletter_topnav_form");
    myform.on("submit", function (ev) {
      ev.preventDefault();
      var userEmail = $('#contact_email_nav');
      if (!myform.valid())
        return;

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          myform[0].reset();
          myform.validate().resetForm();
          $('#success-subscribe-topnav').show();
          $('#success-subscribe-topnav').delay(1000).fadeOut();
          myform.find('.is-valid').removeClass("is-valid");
          myform.find('.is-invalid').removeClass("is-invalid");
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
          // some code here
        }
      });
    });


  });

  $(function () {

    $('#contact_form').validate({
      rules: {
        'contact[email]': {
          required: true,
          email: true
        },
        'contact[chkOptIn]': "required"
      },
      messages: {
        'contact[email]': {
          required: "Please enter email address",
          email: "Please enter a valid email address"
        },
        'contact[chkOptIn]': "Please accept our policy"
      },
      errorElement: "em",
      errorPlacement: function (error, element) {
        // Add the `invalid-feedback` class to the error element
        error.addClass("invalid-feedback");

        /*         if (element.prop("type") === "checkbox") {
                  error.insertAfter($('#agreePolicy').first());
                } else { */
        error.insertAfter(element);
        //}
      },
      highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid").removeClass("is-valid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).addClass("is-valid").removeClass("is-invalid");
      }
    });
  });

  $(function () {

    $('#newsletter_topnav_form').validate({
      rules: {
        'contact[email]': {
          required: true,
          email: true
        },
        'contact[chkOptIn]': "required"
      },
      messages: {
        'contact[email]': {
          required: "Please enter email address",
          email: "Please enter a valid email address"
        },
        'contact[chkOptIn]': "Please accept our policy"
      },
      errorElement: "em",
      errorPlacement: function (error, element) {
        // Add the `invalid-feedback` class to the error element
        error.addClass("invalid-feedback");

        /*         if (element.prop("type") === "checkbox") {
                  error.insertAfter($('#agreePolicy').first());
                } else { */
        error.insertAfter(element);
        //}
      },
      highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid").removeClass("is-valid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).addClass("is-valid").removeClass("is-invalid");
      }
    });
  });
  /* END newsLetter*/

  /* open mini-cart */
  var _showCartPopup = function () {
    this.$cartPopupWrapper = $('[data-cart-popup-wrapper]');
    this.$cartPopup = $('[data-cart-popup]')

    this.$cartPopupWrapper.prepareTransition().removeClass('cart-popup-wrapper--hidden');
    //this._handleButtonLoadingState(false);

    slate.a11y.trapFocus({
      $container: this.$cartPopupWrapper,
      $elementToFocus: this.$cartPopup,
      namespace: 'cartPopupFocus'
    });
  };

  var _hideCartPopup = function (event) {
    //var setFocus = true;

    this.$cartPopupWrapper = $('[data-cart-popup-wrapper]');
    this.$cartPopupImagePlaceholder = $('[data-cart-popup-image-placeholder]');

    this.$cartPopupWrapper
      .prepareTransition()
      .addClass('cart-popup-wrapper--hidden');

    $('this.selectors.cartPopupImage').remove();
    this.$cartPopupImagePlaceholder.removeClass('hide');

    slate.a11y.removeTrapFocus({
      $container: this.$cartPopupWrapper,
      namespace: 'cartPopupFocus'
    });

    //if (setFocus) this.$previouslyFocusedElement[0].focus();

    this.$cartPopupWrapper.off('keyup');
    $('[data-cart-popup-close]').off('click');
    $('[data-cart-popup-dismiss]').off('click');
    $('body').off('click');
  };

  var _onBodyClick = function (event) {
    var $target = $(event.target);

    if (
      $target[0] !== this.$cartPopupWrapper[0] &&
      !$target.parents(this.selectors.cartPopup).length
    ) {
      this._hideCartPopup(event);
    }
  };

  var _setupCartPopupEventListeners = function () {
    $('[data-cart-popup-wrapper]').on(
      'keyup',
      function (event) {
        if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
          this._hideCartPopup(event);
        }
      }.bind(this)
    );

    $('[data-cart-popup-close]').on('click', _hideCartPopup);
    $('[data-cart-popup-dismiss]').on('click', _hideCartPopup);
    //$('body').on('click', _onBodyClick());
  };

  

  $(function () {

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
      cartPopupPlaceholderSize: '[data-placeholder-size]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productThumbListItem: '.product-single__thumbnails-item',
      productThumbsWrapper: '.thumbnails-wrapper',
      shopifyPaymentButton: '.shopify-payment-button',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]'
    };


    this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
    this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
    this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
    this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
    this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
    this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose);
    this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
    this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder);


    $('[data-open-mini-cart]').on('click', function (e) {
      _setupCartPopupEventListeners();
      _showCartPopup();
      return false;
    });
  })

  var owl = $('.topnav_carousel').owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    autoWidth: false,
    animateOut: 'fadeOut',
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  })

  $('.topNavNext').click(function () {
    owl.trigger('next.owl.carousel');
  });

  $('.topNavPrev').click(function () {
    owl.trigger('prev.owl.carousel');
  });

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };


  var isOpenMiniCart = getUrlParameter('openMiniCart');

  if (isOpenMiniCart) {
    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
      cartPopupPlaceholderSize: '[data-placeholder-size]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productThumbListItem: '.product-single__thumbnails-item',
      productThumbsWrapper: '.thumbnails-wrapper',
      shopifyPaymentButton: '.shopify-payment-button',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]'
    };


    this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
    this.$cartPopupWrapper = this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
    this.$cartPopupTitle = this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
    this.$cartPopupQuantity = this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
    this.$cartPopupQuantityLabel = this.$cartPopupQuantityLabel || $(this.selectors.cartPopupQuantityLabel);
    this.$cartPopupClose = this.$cartPopupClose || $(this.selectors.cartPopupClose);
    this.$cartPopupDismiss = this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
    this.$cartPopupImagePlaceholder = this.$cartPopupImagePlaceholder || $(this.selectors.cartPopupImagePlaceholder);

    _setupCartPopupEventListeners();
    _showCartPopup();
    return false;
  }

  $(window).scroll(function() {    
      var scroll = $(window).scrollTop();    
      if (scroll > 100) {
          // $("#shopify-section-header").addClass('collapsed');
      };
      if (scroll <= 100) {
        // $("#shopify-section-header").removeClass('collapsed');
      };
  });

    $(window).scroll(function() {    
      var scroll = $(window).scrollTop();    
      if (scroll > 100) {
          $("#masthead").addClass('collapsed');
      };
      if (scroll <= 100) {
        $("#masthead").removeClass('collapsed');
      };
  }); 
    /* Blog load more */

    $(function () {
      $("#loadMoreArticle .grid__item").click(function () {
        window.open(
          $(this)
            .find("a")
            .attr("href")
        );
      });
      $("#loadMoreArticle .grid__item a").click(function (e) {
        e.stopPropagation();
      });
      $("#loadMoreArticle .grid__item").each(function () {
        if ($(this).data("id") > 5) {
          $(this).hide();
        }
      });

      if ($("#loadMoreArticle .grid__item").length > 12) {
        $("#loadMoreArticle a.button.secondary")
          .show()
          .click(function (e) {
            e.preventDefault();
            $(this).hide();
            $("#loadMoreArticle .grid__item").show();
          });
      }
    });

    $('[id^="btnShare_"]').click(function(e){
      e.preventDefault();

      window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=0, left=0, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
      return false;
      //example
      //window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    });
  
  //***************************** USER LOGIN MODALS *********************************//

  /* User Modal  */
  $('#modalLogin25').on('click',function (e) {
    e.preventDefault();
    $('#loginModalLong').modal('show');

    $('#RegisterUserModal').hide();
    $('#CustomerLoginForm').show();
    $('#RecoverPasswordForm').show();

    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');

  });
 
  $('#modalLogin24').on('click',function (e) {
    e.preventDefault();
    $('#loginModalLong').modal('show');

    $('#RegisterUserModal').hide();
    $('#CustomerLoginForm').show();
    $('#RecoverPasswordForm').show();

    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');

  });


  $('.site-header__icon site-header__account').on('click',function (e) {
    e.preventDefault();
    $('#loginModalLong').modal('show');

    $('#RegisterUserModal').hide();
    $('#CustomerLoginForm').show();
    $('#RecoverPasswordForm').show();

    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');

  });

  $('#loginModalLong').on('hidden.bs.modal', function (e) {
    $("#frmLoginUser").find('.is-invalid').removeClass("is-invalid");
    $("#frmLoginUser").find('.is-valid').removeClass("is-valid");
    $("#frmRecoverPass").find('.is-invalid').removeClass("is-invalid");
    $("#frmRecoverPass").find('.is-valid').removeClass("is-valid");
    $("#frmRegister").find('.is-invalid').removeClass("is-invalid");
    $("#frmRegister").find('.is-valid').removeClass("is-valid");

    $("#frmLoginUser")[0].reset();
    $("#frmRecoverPass")[0].reset();
    $("#frmRegister")[0].reset();

    $("#frmLoginUser").validate().resetForm();
    $("#frmRecoverPass").validate().resetForm();
    $("#frmRegister").validate().resetForm();

    $('#CustomerLoginForm').show();
    $('#RecoverPasswordForm').show();
    $('#RegisterUserModal').hide();
    
  });

  $('#btnCancelRegister').click(function (e) {
    e.preventDefault();
    $('#CustomerLoginForm').show();
    $('#RecoverPasswordForm').show();

    $('#RegisterUserModal').hide();
    $('#btnRegisterUser').prop('disabled', false);
  });

  /* Login User */
  var loginValidation = function () {
    var myform = $("#frmLoginUser");

    myform.on("submit", function (ev) {
      ev.preventDefault();


      if (!myform.valid())
        return;

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          console.log('success');
          var error = jQuery(data).find('.errors').text();
          if (error.length > 0) {
            $('#divErrosMessagesLogin')[0].innerText = "";
            $('#divErrosMessagesLogin').append(error);
            return false;
          } else {
            var  cookieWglang = document.cookie
            .split('; ')
            .find(row => row.startsWith('wglang'))
            
            if(typeof cookieWglang !== 'undefined'){
              cookieWglang = cookieWglang.split('=')[1];
            } 
          
          
            if(typeof cookieWglang !== 'undefined' && cookieWglang==='fr') {
              window.location.href = "https://fr.tuftandneedle.ca/account";
            } else {
              window.location.href = "https://tuftandneedle.ca/account";
            }
          }


/*           $('#contactForm').hide();jQuery(data).find('.errors').text();
          $('#emailSuccess').show();
          myform[0].reset();
 */        },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
          // some code here
        }
      });
    });

  }

  loginValidation();


  $('#frmLoginUser').validate({
    rules: {
      'customer[email]': {
        required: true,
        email: true
      },
      'customer[password]': {
        required: true,
      },
    },
    messages: {
      'customer[email]': {
        required: "Please enter email address",
        email: "Please enter a valid email address"
      },
      'contact[password]': {
        required: "Please provide a password",
      }
    },
    errorElement: "em",
    errorPlacement: function (error, element) {
      // Add the `invalid-feedback` class to the error element
      error.addClass("invalid-feedback");

      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.next("label"));
      } else {
        error.insertAfter(element);
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).addClass("is-valid").removeClass("is-invalid");
    }
  });

  $('#customer_register_link').click(function (e) {
    e.preventDefault();
    $('#CustomerLoginForm').hide();
    $('#RecoverPasswordForm').hide();

    $('#RegisterUserModal').show();
  });

  /* Recover Customer */

  var forgotValidation = function () {
    var myform = $("#frmRecoverPass");

    myform.on("submit", function (ev) {
      ev.preventDefault();

      if (!myform.valid())
        return;

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          var errorTextEn = 'No account found with that email';
          var errorTextFr ='Aucun compte trouvé avec cet e-mail'

          var succesTextEn = "you an email with a link to update your password";
          var succesTextFr = "avons envoyé un courriel avec un lien pour mettre à jour votre mot de passe";
          $('#divErrosMessagesRecovery')[0].innerText = '';

          var errorArray = $($.parseHTML(data)).find('#RecoverEmail-email-error span');
          var emailExist = true;
          if (typeof errorArray != 'undefined' && errorArray.length > 0) {
            var i;
            for (i = 0; i < errorArray.length; i++) {
              if (errorArray[i].innerText.includes(errorTextEn) || errorArray[i].innerText.includes(errorTextFr)  ) {
                emailExist = false;
                break;
              }
            }
          }
          if (emailExist) {
            var succesDiv = $($.parseHTML(data)).find('#ResetSuccess')[0];
            if (typeof succesDiv != 'undefined') 
              if(succesDiv.innerText.includes(succesTextEn)){
                $('#divErrosMessagesRecovery').append(succesDiv.innerText);
                return;
              }else if(succesDiv.innerText.includes(succesTextFr)) {
                $('#divErrosMessagesRecovery').append(succesDiv.innerText);
              return;
            }
            else{
              $('#divErrosMessagesRecovery').append("We couldn't send you the email please contact support.")
            }
          } else {
            $('#divErrosMessagesRecovery').append(errorText);
          }
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          $('#divErrosMessagesRecovery')[0].innerText = '';
          if (xhr.status = 429)
            $('#divErrosMessagesRecovery').append($($.parseHTML(xhr.responseText)).find('.content--block .content--desc')[1].innerText);
          //console.log(thrownError);
          // some code here
        }
      });
    });

  }
  forgotValidation();

  $('#frmRecoverPass').validate({
    rules: {
      'email': {
        required: true,
        email: true
      }
    },
    messages: {
      'email': {
        required: "Please enter email address",
        email: "Please enter a valid email address"
      }
    },
    errorElement: "em",
    errorPlacement: function (error, element) {
      // Add the `invalid-feedback` class to the error element
      error.addClass("invalid-feedback");

      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.next("label"));
      } else {
        error.insertAfter(element);
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).addClass("is-valid").removeClass("is-invalid");
    }
  });

  /* Register Customer */

  var registerValidation = function () {
    var myform = $("#frmRegister");

    myform.on("submit", function (ev) {
      ev.preventDefault();

      if (!myform.valid())
        return;

      $.ajax({
        type: myform.attr('method'),
        url: myform.attr('action'),
        async: true,
        data: myform.serialize(),
        success: function (data) {
          console.log('success');
          var alreadyExist = "email address is already associated with an account";

          if (jQuery(data).find('.form-message--error').text().includes(alreadyExist)) {
            $('#divErrosMessagesRegister').append("This email address is already associated with an account. If this account is yours, you can reset your <a href='#' id='btnRecoverPass'>password</a>");
            $('#btnRegisterUser').prop('disabled', true);
          }
          else {
            var cookieWglang = document.cookie
            .split('; ')
            .find(row => row.startsWith('wglang'))
            
            if(typeof cookieWglang !== 'undefined'){
              cookieWglang = cookieWglang.split('=')[1];
            }
  
           
          if(typeof cookieWglang !== 'undefined' && cookieWglang==='fr' ) {
            window.location.href = "https://fr.tuftandneedle.ca/account";
          } else {
            window.location.href = "https://tuftandneedle.ca/account";
          }


           
          }

          $('#btnRecoverPass').click(function (e) {
            e.preventDefault();
        
            $('#RegisterUserModal').hide(); 
            $('#CustomerLoginForm').show();
            $('#RecoverPasswordForm').show();
            $('#btnRegisterUser').prop('disabled', false);
            $('#RecoverPasswordForm').removeClass('hide');
            $('#CustomerLoginForm').addClass('hide');
          });


        },
        error: function error(xhr, ajaxOptions, thrownError) {
          console.log(thrownError);
          // some code here
        }
      });
    });

  }

  registerValidation();


  $('#frmRegister').validate({
    rules: {
      'customer[first_name]': {
        required: true,
      },
      'customer[last_name]': {
        required: true,
      },
      'customer[email]': {
        required: true,
        email: true
      },
      'customer[password]': {
        required: true,
        minlength: 6
      },
    },
    messages: {
      'customer[first_name]': {
        required: "Please enter first name"
      },
      'customer[last_name]': {
        required: "Please enter last name"
      },
      'customer[email]': {
        required: "Please enter email address",
        email: "Please enter a valid email address"
      },
      'contact[password]': {
        required: "Please provide a password",
        minlength:"Password must be at least 6 characters" 
      }
    },
    errorElement: "em",
    errorPlacement: function (error, element) {
      // Add the `invalid-feedback` class to the error element
      error.addClass("invalid-feedback");

      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.next("label"));
      } else {
        error.insertAfter(element);
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass("is-invalid").removeClass("is-valid");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).addClass("is-valid").removeClass("is-invalid");
    }
  });

  //***************************** END LOGIN MODALS *********************************//

  var isOpenLogin = getUrlParameter('openLogin');

  if(isOpenLogin){
    $('#loginModalLong').modal('show');

    $('#RegisterUserModal').hide();
    $('#CustomerLoginForm').show();
    $('#RecoverPasswordForm').show();

    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }
  $('a[href="https://paybright.com/en/terms-conditions"] ').click(function(e){
    var urlFront = window.location.href;
    var isFrench = urlFront.includes('fr.tuftandneedle')

    if(isFrench)
      window.open('https://paybright.com/fr/terms-conditions');
    else 
      window.open('https://paybright.com/en/terms-conditions');
      return false;
  });

}); // END Jquery Selector   
